// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-new-reason-wrapper {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
}
.add-new-reason-wrapper .addNewReason .contentWrapper {
  display: flex;
  flex-wrap: column;
  gap: 10px;
  overflow-y: auto;
  max-height: 400px;
}
.add-new-reason-wrapper .addNewReason .horizontal-line {
  border: 0;
  border-top: 1px solid #ccc;
  margin: 0px;
  /* Adjust the margin as needed */
  width: 88%;
  margin-left: 30px;
}
.add-new-reason-wrapper .addNewReason .markup {
  height: 25px;
  margin-top: 8px;
  font-size: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.add-new-reason-wrapper .addNewReason .flex-item {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 170px;
  margin-bottom: 8px;
  /* Adjusted for smaller spacing */
  padding: 8px;
  /* Add padding inside each flex item */
  position: relative;
  white-space: nowrap;
  font-size: 11px;
}
.add-new-reason-wrapper .addNewReason .flex-item:first-child {
  min-width: 2px;
  margin-top: 15px;
  margin-left: 30px;
  padding-left: 0%;
  padding-right: 0%;
  /* Reduce min-width for the first item */
}
.add-new-reason-wrapper .addNewReason .flex-item::before {
  content: "";
  position: absolute;
  right: 2;
  left: 0;
  top: 20%;
  bottom: 5%;
  width: 0.2px;
  background-color: #acacac;
}
.add-new-reason-wrapper .addNewReason .flex-item:first-child::before {
  display: none;
  /* Remove left border from the first item */
}
.add-new-reason-wrapper .addNewReason .flex-item > select,
.add-new-reason-wrapper .addNewReason .flex-item > input {
  margin-top: 8px;
  font-size: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.add-new-reason-wrapper .addNewReason .flex-item > select.form-select,
.add-new-reason-wrapper .addNewReason .flex-item > input.form-control {
  width: 100%;
}
.add-new-reason-wrapper .addNewReason .flex-item > input.form-control.border-danger {
  border-color: #acacac !important;
}
.add-new-reason-wrapper .addNewReason .flex-item > input.form-control.border-success {
  height: 25px;
  border-color: #acacaa !important;
}
.add-new-reason-wrapper .addNewReason .header-icons {
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin-top: 15px;
  margin-right: 10px;
  margin-left: 15px;
  /* aligns the delete icon with the input fields */
}

.header-icons.disabled {
  pointer-events: none;
}

.reason-rework-wrapper {
  /* Container styling */
  /* Header and title styling */
  /* Rejection message styling */
  /* Input container styling */
  /* Data table styling */
  /* Add/Delete button styling */
  /* Button styling */
}
.reason-rework-wrapper .container {
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}
.reason-rework-wrapper .header {
  margin-top: -1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.reason-rework-wrapper .header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.reason-rework-wrapper .toggle {
  margin-right: auto;
  margin-bottom: 1rem;
  margin-top: 4px;
}
.reason-rework-wrapper .toggle:hover {
  background: none;
  border: none;
  padding: 0;
  outline: none;
}
.reason-rework-wrapper .header h6 {
  margin: 0;
  color: #003DA5;
}
.reason-rework-wrapper .header p {
  color: #003DA5;
  cursor: pointer;
}
.reason-rework-wrapper .rejection-reason {
  font-size: 1.2rem;
  color: #333;
  font-weight: bold;
}
.reason-rework-wrapper .rejection-add {
  font-size: 1rem;
  color: #003DA5;
  cursor: pointer;
}
.reason-rework-wrapper .input-container {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.reason-rework-wrapper .input-container label {
  margin-right: 1rem;
  font-weight: 500;
}
.reason-rework-wrapper .input-container select {
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  cursor: pointer;
}
.reason-rework-wrapper .data-table {
  margin-bottom: 2rem;
}
.reason-rework-wrapper .data-table .p-datatable-wrapper {
  overflow-x: auto;
  max-height: 210px;
}
.reason-rework-wrapper .datatable-container {
  overflow: hidden;
  border: 1px solid #acacac;
  border-radius: 4px;
}
.reason-rework-wrapper .datatable-container .p-datatable .p-datatable-thead > tr > th {
  background: #edf4fa;
  border-top: none;
  border-right: 1px solid #acacac;
  border-left: 0;
  text-align: left !important;
  width: 50rem;
}
.reason-rework-wrapper .datatable-container .p-datatable .p-datatable-tbody > tr > td {
  text-align: left;
  padding-left: 0 !important;
  /* No padding on the left */
}
.reason-rework-wrapper .button-wrapper {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-left: auto;
  width: fit-content;
}
.reason-rework-wrapper .rework-btn {
  padding-inline: 24px;
  padding-block: 10px;
  border-radius: 20px;
  color: white;
  background-color: #003DA5;
  border: none;
}
.reason-rework-wrapper .data-table table {
  min-width: 50rem;
  width: 100%;
  border-collapse: collapse;
}
.reason-rework-wrapper .data-table th,
.reason-rework-wrapper .data-table td {
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  text-align: left;
}
.reason-rework-wrapper .data-table th {
  background-color: #f7f7f7;
  font-weight: 600;
}
.reason-rework-wrapper .add-delete-buttons {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;
}
.reason-rework-wrapper .button {
  display: flex;
  justify-content: flex-end;
}
.reason-rework-wrapper .button button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  background-color: #003DA5;
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
}
.reason-rework-wrapper .button button:hover {
  background-color: #003DA5;
}
.reason-rework-wrapper .new-component {
  border: 1px solid #acacaa;
  border-radius: 8px;
  max-height: 140px;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/ReasonForRework/index.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EAEA,yBAAA;EACA,kBAAA;AAHJ;AAQQ;EACI,aAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;AANZ;AAUQ;EACI,SAAA;EACA,0BAAA;EACA,WAAA;EACA,gCAAA;EACA,UAAA;EACA,iBAAA;AARZ;AAWQ;EACI,YAAA;EAIA,eAAA;EAEA,eAAA;EACA,sBAAA;EACA,kBAAA;AAbZ;AAgBQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAdZ;AAkBQ;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;AAhBZ;AAoBQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAlBZ;AAuBQ;EACI,aAAA;EACA,2CAAA;AArBZ;AA0BQ;;EAEI,eAAA;EAEA,eAAA;EACA,sBAAA;EACA,kBAAA;AAzBZ;AA4BQ;;EAEI,WAAA;AA1BZ;AA6BQ;EACI,gCAAA;AA3BZ;AA8BQ;EACI,YAAA;EACA,gCAAA;AA5BZ;AA+BQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iDAAA;AA7BZ;;AAoCA;EACI,oBAAA;AAjCJ;;AAsCA;EAGI,sBAAA;EAWA,6BAAA;EA0CA,8BAAA;EAaA,4BAAA;EAmBA,uBAAA;EAyEA,8BAAA;EAOA,mBAAA;AApMJ;AAgCI;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AA9BR;AAkCI;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAhCR;AAmCI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAjCR;AAoCI;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;AAlCR;AAqCI;EACI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;AAnCR;AAuCI;EAEI,SAAA;EACA,cAAA;AAtCR;AA2CI;EACI,cAAA;EACA,eAAA;AAzCR;AA6CI;EACI,iBAAA;EACA,WAAA;EACA,iBAAA;AA3CR;AA8CI;EACI,eAAA;EACA,cAAA;EACA,eAAA;AA5CR;AAgDI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA9CR;AAiDI;EACI,kBAAA;EACA,gBAAA;AA/CR;AAkDI;EACI,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAhDR;AAoDI;EACI,mBAAA;AAlDR;AAqDI;EACI,gBAAA;EAEA,iBAAA;AApDR;AAuDI;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;AArDR;AAuDQ;EACI,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,cAAA;EACA,2BAAA;EACA,YAAA;AArDZ;AAwDQ;EACI,gBAAA;EACA,0BAAA;EACA,2BAAA;AAtDZ;AAgEI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AA9DR;AAiEI;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AA/DR;AAkEI;EACI,gBAAA;EACA,WAAA;EACA,yBAAA;AAhER;AAmEI;;EAEI,gBAAA;EACA,yBAAA;EACA,gBAAA;AAjER;AAoEI;EACI,yBAAA;EACA,gBAAA;AAlER;AAsEI;EACI,aAAA;EACA,8BAAA;EACA,cAAA;AApER;AAwEI;EACI,aAAA;EACA,yBAAA;AAtER;AAyEI;EACI,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAvER;AA0EI;EACI,yBAAA;AAxER;AA2EI;EACI,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAzER","sourcesContent":["$primary: #003da5;\n$secondary: #acacac;\n\n.add-new-reason-wrapper {\n    display: flex;\n    flex-direction: column;\n    // padding: 8px;\n    background-color: #ffffff;\n    border-radius: 8px;\n    // border: 1px solid #acacaa;\n\n\n    .addNewReason {\n        .contentWrapper {\n            display: flex;\n            flex-wrap: column;\n            gap: 10px;\n            overflow-y: auto;\n            max-height: 400px;\n\n        }\n\n        .horizontal-line {\n            border: 0;\n            border-top: 1px solid #ccc;\n            margin: 0px;\n            /* Adjust the margin as needed */\n            width: 88%;\n            margin-left: 30px;\n        }\n\n        .markup {\n            height: 25px;\n            // background-color: #e6f7ff;\n            // border: 1px solid #91d5ff;\n            // border-radius: 4px;\n            margin-top: 8px;\n            // padding: 8px;\n            font-size: 10px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n        }\n\n        .flex-item {\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n            min-width: 170px;\n            margin-bottom: 8px;\n            /* Adjusted for smaller spacing */\n            padding: 8px;\n            /* Add padding inside each flex item */\n            position: relative;\n            white-space: nowrap;\n            font-size: 11px;\n\n        }\n\n        .flex-item:first-child {\n            min-width: 2px;\n            margin-top: 15px;\n            margin-left: 30px;\n            padding-left: 0%;\n            padding-right: 0%;\n            /* Reduce min-width for the first item */\n        }\n\n\n        .flex-item::before {\n            content: '';\n            position: absolute;\n            right: 2;\n            left: 0;\n            top: 20%;\n            bottom: 5%;\n            width: 0.2px;\n            background-color: #acacac;\n\n        }\n\n\n        .flex-item:first-child::before {\n            display: none;\n            /* Remove left border from the first item */\n        }\n\n\n\n        .flex-item>select,\n        .flex-item>input {\n            margin-top: 8px;\n            // padding: 8px;\n            font-size: 10px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n        }\n\n        .flex-item>select.form-select,\n        .flex-item>input.form-control {\n            width: 100%;\n        }\n\n        .flex-item>input.form-control.border-danger {\n            border-color: #acacac !important;\n        }\n\n        .flex-item>input.form-control.border-success {\n            height: 25px;\n            border-color: #acacaa !important;\n        }\n\n        .header-icons {\n            cursor: pointer;\n            width: 20px;\n            height: 20px;\n            margin-top: 15px;\n            margin-right: 10px;\n            margin-left: 15px;\n            /* aligns the delete icon with the input fields */\n\n        }\n\n    }\n}\n\n.header-icons.disabled {\n    pointer-events: none;\n  }\n  \n\n\n.reason-rework-wrapper {\n\n\n    /* Container styling */\n    .container {\n        padding: 2rem;\n        background-color: #ffffff;\n        border-radius: 8px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        width: 90%;\n        max-width: 1200px;\n        margin: 0 auto;\n    }\n\n    /* Header and title styling */\n    .header {\n        margin-top: -1rem;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 1rem;\n    }\n\n    .header-row {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .toggle {\n        margin-right: auto;\n        margin-bottom: 1rem;\n        margin-top: 4px;\n    }\n\n    .toggle:hover {\n        background: none;\n        border: none;\n        padding: 0;\n        outline: none;\n    }\n\n\n    .header h6 {\n        // font-size: 1.5rem;\n        margin: 0;\n        color: #003DA5;\n    }\n\n\n\n    .header p {\n        color: #003DA5;\n        cursor: pointer;\n    }\n\n    /* Rejection message styling */\n    .rejection-reason {\n        font-size: 1.2rem;\n        color: #333;\n        font-weight: bold;\n    }\n\n    .rejection-add {\n        font-size: 1rem;\n        color: #003DA5;\n        cursor: pointer;\n    }\n\n    /* Input container styling */\n    .input-container {\n        display: flex;\n        align-items: center;\n        margin-bottom: 1rem;\n    }\n\n    .input-container label {\n        margin-right: 1rem;\n        font-weight: 500;\n    }\n\n    .input-container select {\n        padding: 0.5rem;\n        border-radius: 4px;\n        border: 1px solid #ccc;\n        cursor: pointer;\n    }\n\n    /* Data table styling */\n    .data-table {\n        margin-bottom: 2rem;\n    }\n\n    .data-table .p-datatable-wrapper {\n        overflow-x: auto;\n        // overflow-y: hidden !important;\n        max-height: 210px;\n    }\n\n    .datatable-container {\n        overflow: hidden;\n        border: 1px solid #acacac;\n        border-radius: 4px;\n\n        .p-datatable .p-datatable-thead>tr>th {\n            background: #edf4fa;\n            border-top: none;\n            border-right: 1px solid #acacac;\n            border-left: 0;\n            text-align: left !important;\n            width: 50rem;\n        }\n\n        .p-datatable .p-datatable-tbody>tr>td {\n            text-align: left;\n            padding-left: 0 !important;\n            /* No padding on the left */\n        }\n\n    }\n\n    // .button-container {\n    //     display: flex;\n    //     align-items: center;\n    //     gap: 24px;\n    //   }\n    .button-wrapper {\n        display: flex;\n        align-items: center;\n        gap: 24px;\n        margin-left: auto;\n        width: fit-content;\n    }\n\n    .rework-btn {\n        padding-inline: 24px;\n        padding-block: 10px;\n        border-radius: 20px;\n        color: white;\n        background-color: #003DA5;\n        border: none;\n    }\n\n    .data-table table {\n        min-width: 50rem;\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    .data-table th,\n    .data-table td {\n        padding: 0.75rem;\n        border: 1px solid #e0e0e0;\n        text-align: left;\n    }\n\n    .data-table th {\n        background-color: #f7f7f7;\n        font-weight: 600;\n    }\n\n    /* Add/Delete button styling */\n    .add-delete-buttons {\n        display: flex;\n        justify-content: space-between;\n        margin: 1rem 0;\n    }\n\n    /* Button styling */\n    .button {\n        display: flex;\n        justify-content: flex-end;\n    }\n\n    .button button {\n        padding: 0.75rem 1.5rem;\n        border: none;\n        border-radius: 4px;\n        background-color: #003DA5;\n        color: #fff;\n        font-size: 1rem;\n        cursor: pointer;\n    }\n\n    .button button:hover {\n        background-color: #003DA5;\n    }\n\n    .new-component {\n        border: 1px solid #acacaa;\n        border-radius: 8px;\n        max-height: 140px;\n        overflow-y: auto;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
